import { useTranslation } from 'react-i18next';

import { Typography } from '@spotnana/blocks/src/Typography';
import { ListBookingPaymentSourcesRequestType } from 'obt-common';
import { flex, margins } from '@spotnana/blocks/src/utils';
import { Icon } from '@spotnana/blocks/src/Icon';
import { spacings } from '@spotnana/blocks/src/utils/styling/utilityTokens';
import { description, warning_icon } from './VirtualCardInfo.styles';

function VirtualCardInfo({ bookingType }: { bookingType: ListBookingPaymentSourcesRequestType }) {
  const { t: tt } = useTranslation('WEB');
  return (
    <div css={margins.y.m1}>
      <div css={[flex.init, flex.align.center, spacings.extraSmall]}>
        <Icon name="ErrorCircle" height={24} width={24} css={warning_icon} />
        <Typography kind="semibold" variant="body1">
          {tt('Virtual Card Instructions')}
        </Typography>
      </div>
      <Typography color="secondary" variant="body2" css={description}>
        {bookingType === ListBookingPaymentSourcesRequestType.HOTEL &&
          tt(
            'Digital payment method provided and paid by your company. You may need to present the card number upon check-in (this can be found within your confirmation in the Trips page).',
          )}
        {bookingType === ListBookingPaymentSourcesRequestType.CAR &&
          tt(
            'Digital payment method provided and paid by your company. You may need to present the card number to the car vendor (this can be found within your confirmation in the Trips page).',
          )}
      </Typography>
    </div>
  );
}

export default VirtualCardInfo;
